"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montegrino-valtravaglia": {
    "4c84ef90": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "skipSearch": false
    }],
    "alpe-del-campogino": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1c43e89a": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "skipSearch": false
    }],
    "casa-briccoli": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2d76b3d8": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "skipSearch": false
    }],
    "casa-compagnoni": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c8a0804e": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "skipSearch": false
    }],
    "casa-de-andrea": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "03d8ea2e": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "skipSearch": false
    }],
    "case-sciare": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2f0f4c1c": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "skipSearch": false
    }],
    "monte-sette-termini-i-bedeloni": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5f75e2e1": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "skipSearch": false
    }],
    "ostino": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c96ca4c7": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "skipSearch": false
    }],
    "piana": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1eb898b8": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "skipSearch": false
    }],
    "pianca": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "30a851f2": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "skipSearch": false
    }],
    "pipetta": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "021661ce": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "skipSearch": false
    }],
    "porsu": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "965aa256": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a863c3ef": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "skipSearch": false
    }],
    "segrada": [{
      "hkey": "c9ccd026",
      "slug": "montegrino-valtravaglia",
      "name": "Montegrino Valtravaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;